<template>
    <div>
        <!-- ChoiceModal A -->
        <base-modal v-if="flow === 'A'" :open="true" :controlled="true" :closeable="false">
            <h2 class="font-bold text-md text-darkblue text-center">Hãy chọn một nội dung hướng dẫn:</h2>

            <div class="p-8">
                <vs-radio class="w-full mb-4 ml-4 text-lg" v-model="pick" vs-name="pick" :vs-value="choices.advertisement">Tạo Hình thức quảng cáo</vs-radio>
                <vs-radio class="w-full mb-4 ml-4 text-lg" v-model="pick" vs-name="pick" :vs-value="choices.createLink">Tạo link đẩy chiến dịch</vs-radio>
            </div>

            <div>
                <Button class="mb-4 w-full" @click="onContinue">Tiếp nào</Button>
            </div>
        </base-modal>

        <!-- ChoiceModal B -->
        <base-modal v-else-if="flow === 'B'" :open="true" :controlled="true" :closeable="false" :customContentClass="{ 'flex flex-col' : true, }">
            <h2 class="font-bold text-xl text-darkblue text-center mb-4">Hướng dẫn Publisher mới</h2>

            <div class="px-2 mb-4">
                Để bắt đầu Affiliate Marketing, HyperLead sẽ hướng dẫn bạn tạo link. <br/>
                Ấn "Bắt đầu” và làm theo chỉ dẫn nhé!
            </div>

            <div class="mt-auto">
                <Button class=" w-full" @click="onContinue(choices.createLink)">Bắt đầu</Button>
            </div>
        </base-modal>
    </div>
</template>

<script>
import userOnboardingService from '../../../core/services/userOnboardingService';
import Button from '../../Button/Button.vue';
import BaseModal from '../../Modal/BaseModal.vue';

export default {
    name: "choice-modal",

    props: {
        flow: {
            type: String,
            default: "",
        }
    },

    components: {
        BaseModal,
        Button,
    },

    data() {
        return {
            pick: "",
            choices: userOnboardingService.tutorial
        }
    },

    methods: {
        onContinue(pick = null) {
            // The condition for onboarding flow B
            if(pick) {
                this.pick = pick;
            }

            this.$emit("continue", { tutorial: this.pick, component: "choice-modal" });
        }
    },

    mounted() {
        window.onbeforeunload = () => {
            return "Are you sure to quit?";
        }

        window.onunload = () => {
            userOnboardingService.hold();
        }
    },

    beforeDestroy() {
        window.onbeforeunload = () => {};
        window.onunload = () => {};
    }
}
</script>

<style lang="scss">
.choice-modal {}
</style>


// WEBPACK FOOTER //
// src/components/UserOnboarding/components/ChoiceModal.vue